import type { NavItem } from '@/lib/types';
import NavigationList from './NavigationList';
import styles from './Sidebar.module.css';

interface SidebarProps {
  items: NavItem[];
  activePath: string;
  collapsed: boolean;
}

export default function Sidebar({ items, activePath, collapsed }: SidebarProps) {
  return (
    <aside className={`${styles.sidebar}${collapsed ? ` ${styles.sidebarCollapsed}` : ''}`}>
      <nav aria-label="Sidebar navigation">
        <NavigationList
          items={items}
          activePath={activePath}
          listClassName={styles.sidebarNav}
          linkClassName={styles.sidebarLink}
          activeClassName={styles.sidebarLinkActive}
          collapsed={collapsed}
        />
      </nav>
    </aside>
  );
}
